import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "../../services/http.service";
import { Descriptor } from "../vo/descriptor";

@Injectable()
export class DescriptorModelService extends BaseModel {
	private _descDocXML: XMLDocument;
	private _txtFields: Descriptor[] = [];

	constructor(private httpService: HttpService) {
		super();
	}

	public initialize(url: string): void {
		this._txtFields = [];
		this.loadDesDoc(url);
	}

	private loadDesDoc(url: string): void {
		this.httpService.getXmlData(url).then((res: any) => {
			this._descDocXML = res;
			this.parseDescriptor();
		});
	}
	private parseDescriptor() {
		this.parseTextFields();
	}
	private parseTextFields(): void {
		let txtFields = this._descDocXML.querySelectorAll("txtField");
		let descriptor: Descriptor;
		let iterator: number = 0,
			node;
		while ((node = txtFields[iterator++])) {
			descriptor = new Descriptor();
			descriptor.id = node.getAttribute("id");
			descriptor.value = node.textContent;
			for (let x = 1; x < node.attributes.length; x++) {
				descriptor.additionalAttrs.push({
					name: node.attributes[x].name,
					value: node.attributes[x].textContent,
				});
			}
			this._txtFields.push(descriptor);
		}
		this._notifier.next("data");
	}

	public get txtFields(): Descriptor[] {
		return this._txtFields;
	}

	public getDescriptorTextById(id: string): string {
		const descriptor: Descriptor = this._txtFields.find(
			(item) => item.id === id
		);
		if (descriptor) {
			return descriptor.value;
		}
		return "";
	}

	public get descDocXml(): any {
		return this._descDocXML;
	}
}
